import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux'
import { selectOrganizationLogo } from './features/organizationReducer'
import { selectExhibit } from './features/exhibitReducer'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import FacebookIcon from '@material-ui/icons/Facebook'
import TwitterIcon from '@material-ui/icons/Twitter'
import { grey } from '@material-ui/core/colors'
import Grid from '@material-ui/core/Grid'
import { FacebookShareButton, TwitterShareButton } from 'react-share'
import { useLocation } from 'react-router-dom'



const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      paddingBottom: 16,
      backgroundColor: '#ffffff',
      borderRadius: 0,
    },
    header: {
      position: 'relative',
      marginLeft: 16,
      marginRight: 32,
    },
    }))

export default function HeaderBar() {
  const orgImage  = useSelector(selectOrganizationLogo)
  const exhibit  = useSelector(selectExhibit)

  const headerStyle = {
    backgroundColor: exhibit.mainColor,
    padding: '0px',
    width: '100%',
  }

  const storyBrand = {
    float: 'left',
    height: 'auto',
    width: 'auto',
    maxHeight: '50px',
    margin: '16px',
  }

  const classes = useStyles()

  const location = useLocation()
  const shareLink = `${process.env.REACT_APP_SERVER_URL}${location.pathname}`

  return (
      <div className={classes.root}>
        <AppBar
          position="static"
          color="transparent"
          >
          <Toolbar style={headerStyle}>
            <Grid>
              <img alt={"organization"} src={orgImage} style={storyBrand} />
            </Grid>
            <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
              >
              <FacebookShareButton
              url={shareLink}
              >
                <FacebookIcon style={{ color: grey[50], opacity: '75%', marginRight: 16  }} />
              </FacebookShareButton>
              <TwitterShareButton
              url={shareLink}
              >
                <TwitterIcon style={{ color: grey[50], opacity: '75%', marginRight: 16  }} />
              </TwitterShareButton>
            </Grid>
          </Toolbar>
        </AppBar>
      </div>
  )
}
